var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.network)?_c('NetworkCard',{attrs:{"network":_vm.network,"showJoin":false}}):_vm._e(),(_vm.media)?_c('CardSmall',{attrs:{"columns":3,"media":_vm.media,"index":0,"network":_vm.network}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }